var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWord = function SvgWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "-3 -3 26 26"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 13,
    fill: "#30CB22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.668 5h.833m0 0 3.714 9.577c.542 1.397.813 2.096 1.271 2.09s.711-.712 1.218-2.123l.047-.133M2.501 5h2.917m3.333 9.411L5.418 5m3.333 9.411 1.93-5.244M5.418 5h.797M8.332 5h.833m0 0 3.715 9.577c.541 1.397.812 2.096 1.27 2.09s.711-.712 1.218-2.123l.047-.133M9.165 5h2.917m3.333 9.411L12.082 5m3.333 9.411 1.691-4.708M12.082 5h.797m4.227 4.703.84-2.007a6.4 6.4 0 0 0 .347-2.892C18.163 3.632 17.63 2.5 16.25 2.5c-1.282 0-1.91 1.436-1.093 2.411 1.317 1.574 2.485 3.318 1.949 4.792"
  })));
};
export default SvgWord;